import { dictionarySection } from "@/content/i18n/dictionaries";
import type { Locale } from "@/lib/i18n/config";

export type PartnerTier = {
  type: "professional" | "business";
  eyebrow: string;
  title: string;
  body: string;
  bullets: string[];
  offer?: string;
  icon: "UserCheck" | "Store";
};

export type PartnerBenefit = {
  title: string;
  body: string;
  icon: "Star" | "Users" | "BarChart3" | "Handshake";
};

type PartnersContent = {
  meta: {
    title: string;
    description: string;
    openGraphDescription: string;
  };
  hero: {
    eyebrow: string;
    title: string;
    subtitle: string;
    body: string;
    ctaLabel: string;
    secondaryCtaLabel: string;
    secondaryCtaAriaLabel: string;
  };
  benefits: {
    eyebrow: string;
    title: string;
    body: string;
    items: PartnerBenefit[];
  };
  tiers: {
    eyebrow: string;
    title: string;
    body: string;
    items: PartnerTier[];
  };
  application: {
    eyebrow: string;
    title: string;
    body: string;
    trustItems: string[];
  };
};

export function getPartners(locale: Locale): PartnersContent {
  return dictionarySection(locale, "partners") as PartnersContent;
}
